import axios from "axios";
import md5 from "md5"
import router from '@/router'



export default {

    namespaced: true,

    state: {
        cat: "CumulativeTotalReturn1Year",
        cacheid: [],
        top15: [],
        currentCount: 10,
        postitionTableCompare: 0,
        dataOfCurrentRowInTableCompare: {
            indexRow: 0,
            type: 1,
            counter: 10
        },
        typeCompareDetail: '',
        isBackBtn: false
    },
    getters: {},
    actions: {

        async getComparison({commit, state}, currency, selector = null) {
            const md5str = md5(router.currentRoute.params.id + currency + selector)
            if (md5str == state.cacheid && state.dataOfCurrentRowInTableCompare.counter == state.currentCount) {
                return state.top15
            } else {
                await axios.get('/search/getcomparison/' + router.currentRoute.params.id,
                    {
                        params: {
                            type: state.cat,
                            native: currency,
                            showtop: router.currentRoute.params.showtop ? router.currentRoute.params.showtop: state.dataOfCurrentRowInTableCompare.counter,
                        }
                    }
                )
                    .then((response) => {

                        let arr = response.data.top15
                        state.currentCount = state.dataOfCurrentRowInTableCompare.counter;

                        if(!response.data.top15.find(obj => router.currentRoute.params.id === obj.ISIN)){
                            arr.push(response.data.focus)
                        }
                        commit("ADD_LIST", response.data.top15)
                        commit("SET_CACHE_ID", md5str)
                    })
                    .catch((error) => {
                        alert(error)
                    })
            }
        },
    },
    mutations: {
        ADD_LIST(state, arr) {
            state.top15 = [...arr]
        },
        SET_CACHE_ID(state, str) {
            state.cacheid = str
        },
        SET_CAT(state, str) {
            state.cat = str
        },
        SET_POSTION_TABLE_COMPARE(state, data) {
            state.postitionTableCompare = data
        },
        SET_DATA_CURRENT_ROW_TABLE(state, data) {
            state.dataOfCurrentRowInTableCompare = data
        },
        SET_TYPE_COMPARE_DETAIL(state, data) {
            state.typeCompareDetail = data;
        },
        SET_TYPE_BACK_BTN(state, data) {
            state.isBackBtn = data;
        }
    }
}


